/*
 * @Description: 
 * @Autor: cherry
 * @Date: 2022-07-28 08:34:49
 * @LastEditors: cherry
 * @LastEditTime: 2022-07-28 09:17:30
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Yuyue {
    /**
    * 获取预约排队列表
    */
    export var getList = (query: any): Promise<any> => {
        return Get(`/msls/LineUp/GetList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取叫号看板数据
    */
    export var GetBoradDatas = (query: any): Promise<any> => {
        return Get(`/msls/LineUp/GetBoradDatas?${qs.stringify(query)}`, {});
    };
    /**
     * 重新预约排队
     */
    export var ReAppointQueue = (id: any): Promise<any> => {
        return Put(`/msls/LineUp/ReAppointQueue/${id}`, {});
    };

    /**
     * 取消预约
     */
     export var CancelAppoint = (id: any): Promise<any> => {
        return Put(`/msls/LineUp/Cancel/${id}`, {});
    };   
    /**
     * 预约排队
     */
     export var AppointQueue = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/AppointQueue`, query);
    };
    /**
     * 签到取号
     */
     export var Sign = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/Sign`, query);
    };
    /**
    * 获取仓库类型
    */
     export var GetWareHouseList = (query:any): Promise<any> => {
        return Get(`/msls/WareHouse/GetWareHouseList?${qs.stringify(query)}`, {});
    };
    /**
    * 获取时间设置窗口
    */
     export var GetTimesInfoList = (query: any): Promise<any> => {
        return Get(`/msls/BasicData/GetTimesInfoList?${qs.stringify(query)}`, {});
    };

    /**
     * 叫号
     */
     export var call = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/Call`, query);
    };
    /**
     * 过号
     */
     export var pass = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/Pass/${query}`, {});
    };
    /**
     * 到场
     */
     export var bePresent = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/BePresent/${query}`, {});
    };
    /**
     * 出场
     */
     export var leavePresent = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/LeavePresent/${query}`, {});
    };
    /**
     * 一键出场
     */
     export var yjLeavePresent = (query: any): Promise<any> => {
        return Post(`/msls/LineUp/LeavePresentAll/${query}`, {});
    };
    /**
    * 获取预约看板数据
    */
    export var GetBoradDatas = (query: any): Promise<any> => {
        return Get(`/msls/LineUp/GetBoradDatas?${qs.stringify(query)}`, {});
    };
    /**
    * 获取今日数据统计
    */
     export var TodayData = (query: any): Promise<any> => {
        return Get(`/msls/LineUp/TodayData?${qs.stringify(query)}`, {});
    };
    /**
    *预约详情 
    */
    export var getYyDetail = (id: any): Promise<any> => {
        return Get(`/msls/LineUp/Detail/${id}`, {});
    };
    /**
     * 提示
     */
     export var getTips = (id: any): Promise<any> => {
        return Get(`/msls/LineUp/GetTips/${id}`, {});
    };
}
